export default __webpack_public_path__ + "static/media/206.a5896d70.jpg";